// Meta Pixel (Facebook/Instagram) voor advertentiemeting. Het meetpunt is een
// publiceerbaar ID (het staat in de bron van elke site met Meta-meting), dus
// het mag hier letterlijk staan.
// De pixel laadt alleen na expliciete cookie-toestemming (zelfde route als de
// Google-meting): geen toestemming, geen script, geen cookies, geen events.
import { leesConsent } from "@/lib/consent";

export const META_PIXEL_ID = "1498041179039560";

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

let metaInitialized = false;

export function initMetaPixel() {
  if (typeof window === "undefined") return;
  window.addEventListener("eo-consent-changed", loadMetaPixel);
  window.addEventListener("storage", (event) => {
    if (event.key === "eo-cookie-consent" && leesConsent() === "geaccepteerd") loadMetaPixel();
  });
  loadMetaPixel();
}

function loadMetaPixel() {
  if (typeof window === "undefined" || metaInitialized) return;
  if (leesConsent() !== "geaccepteerd") return;
  metaInitialized = true;

  if (!window.fbq) {
    // Meta's standaard-samenvatting: aanroepen vóórdat fbevents.js geladen is
    // belanden in de wachtrij; fbevents.js zet daarna callMethod op dit object.
    const fbq = function metaFbq(...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue?.push(args);
      }
    } as Fbq;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.push = function push(...args: unknown[]) {
      fbq.queue?.push(args);
    };
    window.fbq = fbq;
    window._fbq = fbq;

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }

  window.fbq?.("init", META_PIXEL_ID);
  window.fbq?.("track", "PageView");
}

/** Paginaweergave voor Meta bij routeveranderingen (alleen met toestemming). */
export function trackMetaPageView() {
  if (typeof window === "undefined" || leesConsent() !== "geaccepteerd") return;
  window.fbq?.("track", "PageView");
}

/**
 * Eén bevestigde, opgeslagen aanvraag wordt een Meta Lead-event, met het
 * unieke aanvraagnummer als event-ID (deduplicatie). Geen klantgegevens.
 */
export function trackMetaLead(leadId: string) {
  if (typeof window === "undefined" || leesConsent() !== "geaccepteerd") return;
  window.fbq?.("track", "Lead", {}, { eventID: leadId });
}
